import type { ThemeAssetEntry } from '@goodtime/engine';
import { friendAlias, THEME_FRIENDS, type FriendId, type FriendPose } from '@goodtime/shared';

const POSES = import.meta.glob<string>('../../assets/road/friends/*.png', { eager: true, import: 'default' });

/** A friend's picture in one pose. */
export function friendArt(id: FriendId, pose: FriendPose = 'greet'): string | undefined {
  return POSES[`../../assets/road/friends/${id}_${pose}.png`];
}

/** One slot's friends as road art, both poses each (`road:friend_<id>`,
 *  `road:friend_<id>_cheer`), loaded with the rest of the road. Their
 *  games' lamp icons come with the games (`road:game_<kind>`). */
export function roadFriendTextures(themeId: string): Record<string, ThemeAssetEntry> {
  const entries: Record<string, ThemeAssetEntry> = {};
  for (const id of THEME_FRIENDS[themeId] ?? []) {
    for (const pose of ['greet', 'cheer'] as const) {
      const src = friendArt(id, pose);
      const alias = friendAlias(id, pose);
      if (src) entries[alias.slice('road:'.length)] = { alias, src, path: `road/friends/${id}_${pose}.png` };
    }
  }
  return entries;
}
